// Extract the DOM node which matches a specific data-test-id value.
export const findTestId = (mountedComponent, testId, isDOMNode = true) => {
  const testSubject = mountedComponent.find(`[data-test-id="${testId}"]`);

  if (isDOMNode) {
    return testSubject.hostNodes().getDOMNode();
  }

  return testSubject;
};



// WEBPACK FOOTER //
// ./services/test/findTestId.js